import React, { Component } from 'react';
import { Form, Modal, TimePicker, } from 'antd';
import { TransitmodeComb } from 'components/Playlist'

import moment from 'moment';

const format = 'HH:mm:ss';
const FormItem = Form.Item;

class BatchEditMaterial extends Component {

  constructor(props){
    super(props);
    this.state = {
      localplaytime: '',
      localtransitmode: '',
      localtransittime: '',
    };
  }

  initState = (props) => {
    let {
      playtime,
      transitmode,
      transittime,
    } = props;
    this.setState({
      localplaytime: playtime,
      localtransitmode: transitmode,
      localtransittime: transittime,
    })
  }
  componentDidMount(){
    this.initState(this.props);
  }
  componentWillReceiveProps(nextprops){
    this.initState(nextprops);
  }

  onEdit = (type, value) => {
    if(type === 'playtime'){
      this.setState({
        localplaytime: value
      })
    }else if(type === 'transitmode'){
      this.setState({
        localtransitmode: value
      })
    }else if(type === 'transittime'){
      this.setState({
        localtransittime: value
      })
    }
  }
  render() {
    const { visible, form, 
      showBatchEditMaterial, 
      hideBatchEditMaterial, 
      handlerBatchEditMaterial,
      ...otherField } = this.props;

    const {
      localplaytime,
      localtransitmode,
      localtransittime,
    } = this.state;

    const formItemLayout = {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 },
    };

    return (
        visible && 
        <Modal
          title='批量编辑（只针对图片）'
          visible={visible}
          {...otherField}
          onCancel={ hideBatchEditMaterial }
          onOk={ () => {
            handlerBatchEditMaterial({playtime: localplaytime, transitmode: localtransitmode, transittime: localtransittime})
          } }
        >
          <Form layout="horizontal">
            <FormItem {...formItemLayout} label="播放时长">
              <TimePicker 
                value={moment(localplaytime, format)} 
                defaultValue={moment(localplaytime, format)}
                format={format}  
                style={{ width: 160 }}
                onChange={(value, valueString) => { 
                    this.onEdit('playtime', valueString, ) 
                  }
                } readOnly />
            </FormItem>
            <FormItem {...formItemLayout} label="转场模式">
              <TransitmodeComb
                value={ localtransitmode } 
                defaultValue={ localtransitmode } 
                style={{ width: 160 }}
                onSelect={(value) => { 
                    this.onEdit('transitmode', value, ) 
                  }
                } readOnly/>
            </FormItem>
          </Form>
        </Modal>
    )
  }
}

export default Form.create()(BatchEditMaterial);


// WEBPACK FOOTER //
// ./src/components/Playlist/BatchEditMaterial.js